import { app } from '../../../../app';
import { Controller } from './sms-usage-report.controller';

app.component('smsUsageReport', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./sms-usage-report.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/sms-usage-report/sms-usage-report.component.js